export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-clock-df75909a324a6870fe420f7e09d84231.svg";